import { render, staticRenderFns } from "./Contactform.vue?vue&type=template&id=12805e90&"
import script from "./Contactform.vue?vue&type=script&lang=js&"
export * from "./Contactform.vue?vue&type=script&lang=js&"
import style0 from "./Contactform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports